import { z } from 'zod/v4';

/**
 * Body for the manual supplier-link write (`PUT /integrations/amfori/suppliers/:companyId`).
 *
 * `amforiSiteId`:
 * - a non-empty (trimmed) string → set/correct the supplier's amfori site id;
 * - `null` → unlink (clear the site id).
 *
 * A `…-000` value is rejected: in amfori's `NNN-NNNNNN-NNN` id scheme the `-000`
 * suffix is the **Business Partner** id, never a site — a common copy/paste
 * mistake off the sync report that could never match a synced site.
 */
export const AmforiSupplierLinkUpdateInputSchema = z
  .object({
    amforiSiteId: z
      .string()
      .trim()
      .min(1)
      .refine(v => !v.endsWith('-000'), {
        message:
          'amforiSiteId is a Business Partner ID (ends in -000); provide the amfori Site ID (e.g. 008-000012-001).',
      })
      .nullable(),
  })
  .strict();

export type AmforiSupplierLinkUpdateInput = z.infer<
  typeof AmforiSupplierLinkUpdateInputSchema
>;
